import React from "react";
import initialCall, { initialCallPaths } from "@helpers/initial-call";
import { GetStaticPropsContext } from "next";
import MainVendorPage from "@components/shared/mainVendorPage";
export interface VendorsToCompare {
    slug: string;
    label: string;
    logo: string;
    category: string;
}
const VendorPage = ({ title, url }: { title: string; url: string }) => {
    return <MainVendorPage title={title} url={url} />;
};

export function getStaticPaths() {
    return initialCallPaths();
}

export async function getStaticProps(ctx: GetStaticPropsContext) {
    return await initialCall("VendorId", ctx);
}

export default VendorPage;
